var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4182 0 16 3.58145 16 8C16 12.4182 12.4182 16 8 16C3.58182 16 0 12.4182 0 8C1.28851e-07 3.58145 3.58182 1.28844e-07 8 0Z",
    fill: "#00AD3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C8.23012 3 8.41699 3.18687 8.41699 3.41699V7.58301H12.583C12.8131 7.58301 13 7.76988 13 8C13 8.23012 12.8131 8.41699 12.583 8.41699H8.41699V12.583C8.41699 12.8131 8.23012 13 8 13C7.76988 13 7.58301 12.8131 7.58301 12.583V8.41699H3.41699C3.18687 8.41699 3 8.23012 3 8C3 7.76988 3.18687 7.58301 3.41699 7.58301H7.58301V3.41699C7.58301 3.18687 7.76988 3 8 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.1a4a8d64f7a2deb71131359eb2d94eb5.svg";
export { ForwardRef as ReactComponent };